import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Emitter } from '../../../base/common/event.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { Range } from '../../common/core/range.js';
import { MATCHES_LIMIT } from './findModel.js';

function effectiveOptionValue(override, value) {
  if (override === 1
  /* True */
  ) {
    return true;
  }

  if (override === 2
  /* False */
  ) {
    return false;
  }

  return value;
}

export var FindReplaceState = /*#__PURE__*/function (_Disposable) {
  _inherits(FindReplaceState, _Disposable);

  var _super = _createSuper(FindReplaceState);

  function FindReplaceState() {
    var _this;

    _classCallCheck(this, FindReplaceState);

    _this = _super.call(this);
    _this._onFindReplaceStateChange = _this._register(new Emitter());
    _this.onFindReplaceStateChange = _this._onFindReplaceStateChange.event;
    _this._searchString = '';
    _this._replaceString = '';
    _this._isRevealed = false;
    _this._isReplaceRevealed = false;
    _this._isRegex = false;
    _this._isRegexOverride = 0
    /* NotSet */
    ;
    _this._wholeWord = false;
    _this._wholeWordOverride = 0
    /* NotSet */
    ;
    _this._matchCase = false;
    _this._matchCaseOverride = 0
    /* NotSet */
    ;
    _this._preserveCase = false;
    _this._preserveCaseOverride = 0
    /* NotSet */
    ;
    _this._searchScope = null;
    _this._matchesPosition = 0;
    _this._matchesCount = 0;
    _this._currentMatch = null;
    _this._loop = true;
    return _this;
  }

  _createClass(FindReplaceState, [{
    key: "searchString",
    get: function get() {
      return this._searchString;
    }
  }, {
    key: "replaceString",
    get: function get() {
      return this._replaceString;
    }
  }, {
    key: "isRevealed",
    get: function get() {
      return this._isRevealed;
    }
  }, {
    key: "isReplaceRevealed",
    get: function get() {
      return this._isReplaceRevealed;
    }
  }, {
    key: "isRegex",
    get: function get() {
      return effectiveOptionValue(this._isRegexOverride, this._isRegex);
    }
  }, {
    key: "wholeWord",
    get: function get() {
      return effectiveOptionValue(this._wholeWordOverride, this._wholeWord);
    }
  }, {
    key: "matchCase",
    get: function get() {
      return effectiveOptionValue(this._matchCaseOverride, this._matchCase);
    }
  }, {
    key: "preserveCase",
    get: function get() {
      return effectiveOptionValue(this._preserveCaseOverride, this._preserveCase);
    }
  }, {
    key: "actualIsRegex",
    get: function get() {
      return this._isRegex;
    }
  }, {
    key: "actualWholeWord",
    get: function get() {
      return this._wholeWord;
    }
  }, {
    key: "actualMatchCase",
    get: function get() {
      return this._matchCase;
    }
  }, {
    key: "actualPreserveCase",
    get: function get() {
      return this._preserveCase;
    }
  }, {
    key: "searchScope",
    get: function get() {
      return this._searchScope;
    }
  }, {
    key: "matchesPosition",
    get: function get() {
      return this._matchesPosition;
    }
  }, {
    key: "matchesCount",
    get: function get() {
      return this._matchesCount;
    }
  }, {
    key: "currentMatch",
    get: function get() {
      return this._currentMatch;
    }
  }, {
    key: "changeMatchInfo",
    value: function changeMatchInfo(matchesPosition, matchesCount, currentMatch) {
      var changeEvent = {
        moveCursor: false,
        updateHistory: false,
        searchString: false,
        replaceString: false,
        isRevealed: false,
        isReplaceRevealed: false,
        isRegex: false,
        wholeWord: false,
        matchCase: false,
        preserveCase: false,
        searchScope: false,
        matchesPosition: false,
        matchesCount: false,
        currentMatch: false,
        loop: false
      };
      var somethingChanged = false;

      if (matchesCount === 0) {
        matchesPosition = 0;
      }

      if (matchesPosition > matchesCount) {
        matchesPosition = matchesCount;
      }

      if (this._matchesPosition !== matchesPosition) {
        this._matchesPosition = matchesPosition;
        changeEvent.matchesPosition = true;
        somethingChanged = true;
      }

      if (this._matchesCount !== matchesCount) {
        this._matchesCount = matchesCount;
        changeEvent.matchesCount = true;
        somethingChanged = true;
      }

      if (typeof currentMatch !== 'undefined') {
        if (!Range.equalsRange(this._currentMatch, currentMatch)) {
          this._currentMatch = currentMatch;
          changeEvent.currentMatch = true;
          somethingChanged = true;
        }
      }

      if (somethingChanged) {
        this._onFindReplaceStateChange.fire(changeEvent);
      }
    }
  }, {
    key: "change",
    value: function change(newState, moveCursor) {
      var _this2 = this;

      var updateHistory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var _a;

      var changeEvent = {
        moveCursor: moveCursor,
        updateHistory: updateHistory,
        searchString: false,
        replaceString: false,
        isRevealed: false,
        isReplaceRevealed: false,
        isRegex: false,
        wholeWord: false,
        matchCase: false,
        preserveCase: false,
        searchScope: false,
        matchesPosition: false,
        matchesCount: false,
        currentMatch: false,
        loop: false
      };
      var somethingChanged = false;
      var oldEffectiveIsRegex = this.isRegex;
      var oldEffectiveWholeWords = this.wholeWord;
      var oldEffectiveMatchCase = this.matchCase;
      var oldEffectivePreserveCase = this.preserveCase;

      if (typeof newState.searchString !== 'undefined') {
        if (this._searchString !== newState.searchString) {
          this._searchString = newState.searchString;
          changeEvent.searchString = true;
          somethingChanged = true;
        }
      }

      if (typeof newState.replaceString !== 'undefined') {
        if (this._replaceString !== newState.replaceString) {
          this._replaceString = newState.replaceString;
          changeEvent.replaceString = true;
          somethingChanged = true;
        }
      }

      if (typeof newState.isRevealed !== 'undefined') {
        if (this._isRevealed !== newState.isRevealed) {
          this._isRevealed = newState.isRevealed;
          changeEvent.isRevealed = true;
          somethingChanged = true;
        }
      }

      if (typeof newState.isReplaceRevealed !== 'undefined') {
        if (this._isReplaceRevealed !== newState.isReplaceRevealed) {
          this._isReplaceRevealed = newState.isReplaceRevealed;
          changeEvent.isReplaceRevealed = true;
          somethingChanged = true;
        }
      }

      if (typeof newState.isRegex !== 'undefined') {
        this._isRegex = newState.isRegex;
      }

      if (typeof newState.wholeWord !== 'undefined') {
        this._wholeWord = newState.wholeWord;
      }

      if (typeof newState.matchCase !== 'undefined') {
        this._matchCase = newState.matchCase;
      }

      if (typeof newState.preserveCase !== 'undefined') {
        this._preserveCase = newState.preserveCase;
      }

      if (typeof newState.searchScope !== 'undefined') {
        if (!((_a = newState.searchScope) === null || _a === void 0 ? void 0 : _a.every(function (newSearchScope) {
          var _a;

          return (_a = _this2._searchScope) === null || _a === void 0 ? void 0 : _a.some(function (existingSearchScope) {
            return !Range.equalsRange(existingSearchScope, newSearchScope);
          });
        }))) {
          this._searchScope = newState.searchScope;
          changeEvent.searchScope = true;
          somethingChanged = true;
        }
      }

      if (typeof newState.loop !== 'undefined') {
        if (this._loop !== newState.loop) {
          this._loop = newState.loop;
          changeEvent.loop = true;
          somethingChanged = true;
        }
      } // Overrides get set when they explicitly come in and get reset anytime something else changes


      this._isRegexOverride = typeof newState.isRegexOverride !== 'undefined' ? newState.isRegexOverride : 0
      /* NotSet */
      ;
      this._wholeWordOverride = typeof newState.wholeWordOverride !== 'undefined' ? newState.wholeWordOverride : 0
      /* NotSet */
      ;
      this._matchCaseOverride = typeof newState.matchCaseOverride !== 'undefined' ? newState.matchCaseOverride : 0
      /* NotSet */
      ;
      this._preserveCaseOverride = typeof newState.preserveCaseOverride !== 'undefined' ? newState.preserveCaseOverride : 0
      /* NotSet */
      ;

      if (oldEffectiveIsRegex !== this.isRegex) {
        somethingChanged = true;
        changeEvent.isRegex = true;
      }

      if (oldEffectiveWholeWords !== this.wholeWord) {
        somethingChanged = true;
        changeEvent.wholeWord = true;
      }

      if (oldEffectiveMatchCase !== this.matchCase) {
        somethingChanged = true;
        changeEvent.matchCase = true;
      }

      if (oldEffectivePreserveCase !== this.preserveCase) {
        somethingChanged = true;
        changeEvent.preserveCase = true;
      }

      if (somethingChanged) {
        this._onFindReplaceStateChange.fire(changeEvent);
      }
    }
  }, {
    key: "canNavigateBack",
    value: function canNavigateBack() {
      return this.canNavigateInLoop() || this.matchesPosition !== 1;
    }
  }, {
    key: "canNavigateForward",
    value: function canNavigateForward() {
      return this.canNavigateInLoop() || this.matchesPosition < this.matchesCount;
    }
  }, {
    key: "canNavigateInLoop",
    value: function canNavigateInLoop() {
      return this._loop || this.matchesCount >= MATCHES_LIMIT;
    }
  }]);

  return FindReplaceState;
}(Disposable);